import template from "./media.html";
import controller from "./media.controller";
import "./media.scss";

const MediaComponent = {
    template,
    controller,
    controllerAs: "media"
};

export default MediaComponent;


// WEBPACK FOOTER //
// ./sources/components/media/media.component.js